import BigDecimal from 'js-big-decimal';



class ShoppingCartSystem{
  clientAccountId;
  totalAmount;
  merchantProductItemArray = [];

  constructor(_framework) {
    this.framework = _framework;
  }

  clear() {
    this.merchantProductItemArray.clear();
  }

  addMerchantProductItem(merchantProduct,count) {
    this.merchantProductItemArray.add(merchantProduct);
    let merchantProductPrice = new BigDecimal(merchantProduct.productPrice);
    let merchantProductCount = new BigDecimal(count);
    let merchantProductAmount = merchantProductPrice.multiply(merchantProductCount);
    let totalAmountBigDecimal = new BigDecimal(this.totalAmount);
    let resultBigDecimal = totalAmountBigDecimal.add(merchantProductAmount);
    this.totalAmount = resultBigDecimal.getValue();
  }


  loadFromStorage() {
    this.clientAccountId = this.getClientAccountId();
    this.totalAmount  = this.getTotalAmount();
    this.merchantProduct  = this.getStoredMerchantProductArray();
  }

  getStoredClientAccountId() {
    return localStorage.getItem('clientAccountId');
  }

  getStoredTotalAmount() {
    return localStorage.getItem('totalAmount');
  }

  getStoredMerchantProductItemArray() {
    return JSON.parse(localStorage.getItem('merchantProductItemArray'));
  }  

  storeClientAccountId(_clientAccountId) {
    localStorage.setItem("clientAccountId",_clientAccountId);
  }

  storeTotalAmount(_totalAmount) {
    localStorage.setItem("totalAmount",_totalAmount);
  }

  storeMerchantProductItemArray(_merchantProductItemArray) {
    localStorage.setItem("merchantProductItemArray",_merchantProductItemArray);
  }  

}

export default ShoppingCartSystem;